export default {
  anyMistakes:
    'Si vous pensez que certaines informations de cette page sont erronées, merci de',
  contactUs: 'nous contacter',
  social: 'Nous sommes sociaux | Suivez nous',
}
